export const phoneNumbers = [
  '(111) 111-1111',
  '(222) 222-2222',
  '(333) 333-3333',
  '(444) 444-4444',
  '(555) 555-5555',
  '(666) 666-6666',
  '(777) 777-7777',
  '(999) 999-9999',
];

export const middleNumber = [
  800,
  866,
  888,
  900,
  911,
];

export const blockingSsns = [
  '078-05-1120',
  '219-09-9999',
  '111-11-1111',
  '222-22-2222',
  '333-33-3333',
  '444-44-4444',
  '555-55-5555',
  '666-66-6666',
  '777-77-7777',
  '888-88-8888',
  '999-99-9999',
  '123-45-6789',
];

export const blockingEmails = [
  'none@none.com',
  'noemail@noemail.com',
  'noemail@gmail.com',
  'noemail@email.com',
  'none@noemail.COM',
  'none@gmail.com',
  'none@yahoo.com',
  'no@no.com',
  'no@email.com',
  'noemail@yahoo.com',
  'test@test.com',
  'na@na.com',
  'noname@gmail.com',
  'no@gmail.com',
  'noemail@mail.com',
  'test@email.com',
  'unknown@yahoo.com',
  'non@non.com',
  'noemal@noemail.com',
  'none@email.com',
  'noname@email.com',
  'noemail@no.com',
  'non@none.com',
  'email@email.com',
  'nomail@gmail.com',
  'noemail@gimail.com',
  'noemail@aol.com',
  'na@gmail.com',
  'noemail@gmai.com',
  'noemail@noemai.com',
  'none@aol.com',
  'na@na.com',
  'noemail@aol.com',
];

export const blockingFederalTax = [
  '00-0000000',
  '11-1111111',
  '22-2222222',
  '33-3333333',
  '44-4444444',
  '55-5555555',
  '66-6666666',
  '77-7777777',
  '88-8888888',
  '99-9999999',
  '12-3456789',
];
